module.exports = __webpack_public_path__ + "static/illustration-sm-0625627531d038ee208b738706389c62.png";